import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const ProductCardWrapper = styled.div<{ vertical?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  border: 1px solid ${props => props.theme.color.line};
  padding: 1rem;
  min-height: 12rem;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  ${props =>
    props.vertical &&
    css`
      grid-template-columns: 1fr;
    `};
`

export const ProductCardMedia = styled.div`
  flex: 0 0 20%;
  aspect-ratio: 1 / 1;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`

export const ProductCardContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 1rem 0;
  flex: 1 1 auto;
  align-items: flex-start;
`

export const ProductCardTop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
`

export const ProductCardInfo = styled.div`
  min-width: 0;
`

export const ProductCardTitle = styled.h4`
  font-size: 1.35rem;
  line-height: 1.1;
  margin-bottom: 0.15rem;
  overflow: hidden;
`

export const ProductCardDuration = styled.p`
  font-size: 0.9rem;
  margin-bottom: 0;
  font-weight: 500;
  color: ${props => props.theme.color.muted};
`

export const ProductCardPricing = styled.div`
  text-align: right;
  flex-shrink: 0;
`

export const ProductCardPrice = styled.p`
  font-size: 1.35rem;
  line-height: 1.05;
  margin-bottom: 0.25rem;
  font-weight: 600;
`

export const ProductCardOldPrice = styled.p`
  font-size: 0.75rem;
  margin-bottom: 0;
  color: ${props => props.theme.color.muted};
`

export const ProductCardBottom = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const ProductCardLabels = styled.div`
  text-align: right;

  strong {
    font-weight: 500;
    display: block;
    font-size: 0.9rem;
    line-height: 1.1;
  }

  span {
    display: block;
    font-size: 0.7rem;
    color: ${props => props.theme.color.muted};
    margin-top: 0.25rem;
  }
`

export const ProductCardSlots = styled.div`
  display: flex;
  gap: 0.25rem;
`

export const ProductCardNoSlotsMessage = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: ${props => props.theme.color.muted};
  font-weight: 500;
`

export const ProductCardSelectButton = styled.button<{ active?: boolean }>`
  ${Reset('button')}
  border: 1px solid ${props => props.theme.color.line};
  color: ${props => (props.active ? props.theme.color.inverted : props.theme.color.global)};
  min-height: 3.5rem;
  min-width: 10rem;
  padding: 0 1.25rem;
  font-size: 1rem;
  font-weight: 600;

  &:disabled {
    opacity: 0.45;
    pointer-events: none;
  }
`

export const ProductCardMoreButton = styled.button`
  ${Reset('button')}
  border: 1px solid ${props => props.theme.color.line};
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 500;
`

export const ProductCardMoreBadge = styled.span`
  width: 1.65em;
  height: 1.65em;
  border-radius: 999px;
  background: ${props => props.theme.color.secondary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 500;
`

export const ProductCardLockButton = styled.button`
  ${Reset('button')}
  border: 1px solid ${props => props.theme.color.line};
  background: ${props => props.theme.color.light};
  min-height: 3.5rem;
  font-size: 1rem;
  font-weight: 600;
  min-width: 10rem;
  padding: 0 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`
